export type SpriteCacheEntry = { updated: string | number; url: string; ts: number };

const KEY = 'spritePreviewCache:v1';
const TTL = 10 * 60 * 1000; // 10 min
let mem: Record<string, SpriteCacheEntry> | null = null;

function load(): Record<string, SpriteCacheEntry> {
  if (mem) return mem;
  try { mem = JSON.parse(sessionStorage.getItem(KEY) || '{}'); }
  catch { mem = {}; }
  return mem!;
}

function saveDebounced() {
  queueMicrotask(() => {
    try { sessionStorage.setItem(KEY, JSON.stringify(mem || {})); } catch {}
  });
}

export function getPreview(id: string, updated?: any): string | undefined {
  const c = load()[id];
  if (!c) return;
  if (updated != null && c.updated !== updated) return;            // invalidera om updated ändrats
  if (Date.now() - c.ts > TTL) return;                             // enkel TTL
  return c.url;
}

export function setPreview(id: string, updated: any, url: string) {
  const c = load();
  c[id] = { updated, url, ts: Date.now() };
  saveDebounced();
}